<ion-header [translucent]='true' mode='md'>
  <ion-toolbar>
    @if (orderType === OrderType.delivery) {
      <ion-title>{{ 'ordersModal.deliveryOrdersTitle' | translate }}</ion-title>
    }
    @if (orderType === OrderType.return) {
      <ion-title>{{ 'ordersModal.returnOrdersTitle' | translate }}</ion-title>
    }
    <ion-buttons slot='end'>
      <ion-button (click)='dismiss()'>{{ 'ordersModal.closeButton' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]='true'>
  <div class='content-wrapper'>
    <ion-refresher slot='fixed' (ionRefresh)='refresh($event)'>
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <ion-row class='border-bottom'>
      <ion-col class='ion-padding-start'>
        @if (orderType === OrderType.delivery) {
          <ion-text class='ion-float-left title'>{{
              'ordersModal.deliveryOrdersTitle' | translate
            }}
          </ion-text>
        }
        @if (orderType === OrderType.return) {
          <ion-text class='ion-float-left title'>{{
              'ordersModal.returnOrdersTitle' | translate
            }}
          </ion-text>
        }
        @if (returnFields) {
          @if (returnFields.length > 0) {
            <ion-text class='ion-float-left quantityTitle returnFields'
            >({{ 'ordersModal.returnField' | translate }}: {{ returnFields }}
              )
            </ion-text>
          }
        }
        @if (orderType === OrderType.delivery) {
          <ion-text class='ion-float-right quantityTitle'>{{
              'ordersModal.delivered' | translate
            }}
          </ion-text>
        }
        @if (orderType === OrderType.return) {
          <ion-text class='ion-float-right quantityTitle'>{{
              'ordersModal.shortage' | translate
            }}
          </ion-text>
        }
        @if (orderType === OrderType.return) {
          <ion-text class='ion-float-right ion-margin-end quantityTitle'>{{
              'ordersModal.returned' | translate
            }}
          </ion-text>
        }
        <ion-text class='ion-float-right ion-margin-end quantityTitle'>{{ 'ordersModal.quantity' | translate }}
        </ion-text>
      </ion-col>
    </ion-row>

    @for (order of orders; track order; let i = $index) {
      <ion-row>
        <ion-col>
          <ion-text
            class='ion-float-left text'>{{ showArticleIdInsteadofDesc ? order.articleId : order.articleDescription }}
          </ion-text>
          @if (orderType === OrderType.return) {
            <ion-text
              class='ion-float-right ion-margin-start quantity opacity'
              [ngStyle]="order.shortage > 0 && { color: 'red' }"
            >
              {{ order.shortage || 0 }}
            </ion-text>
          }
          <div class='ion-float-right quantity'>
            @if (orderType === OrderType.delivery) {
              <ion-input
                type='number'
                pattern='[0-9]*'
                [max]='order.ordered'
                [min]='0'
                [disabled]='
              !forceInputAllowed && order.status !== OrderStatusEnum.editableForOnlyMechanics ||
                (!forceInputAllowed && user.role === UserRole.executor && order.status === OrderStatusEnum.editableForOnlyMechanics)
            '
                [(ngModel)]='order.delivered'
                [placeholder]="'.....'"
                (ngModelChange)='onChange(order)'
              ></ion-input>
            }
            @if (orderType === OrderType.return) {
              <ion-input
                type='number'
                pattern='[0-9]*'
                [min]='0'
                [disabled]='
              (order.status >= OrderStatusEnum.editableForNoOne ||
                (user.role === UserRole.mechanic &&
                  order.status === OrderStatusEnum.editableForExecutorsAndWharfMechanics &&
                  !hasWharfOption())) === false
                ? order.returned > 0 && isEdited === false
                : true
            '
                [(ngModel)]='order.returned'
                [placeholder]="'.....'"
                (ngModelChange)='onChange(order)'
              ></ion-input>
            }
          </div>
          @if (orderType === OrderType.delivery) {
            <ion-text
              class='ion-float-right ion-margin-end quantity'>{{ order.ordered }}
            </ion-text>
          }
          @if (orderType === OrderType.return) {
            <ion-text
              class='ion-float-right ion-margin-end quantity'>{{ order.rented }}
            </ion-text>
          }
        </ion-col>
      </ion-row>
    }
  </div>

  <ion-row>
    <ion-col>
      <ion-button class='save-button' [disabled]='saveButtonDisabled || (!isEdited && !hasWharfOption())'
                  (click)='save()' expand='block'>{{
          'ordersModal.saveButton' | translate
        }}
      </ion-button>
    </ion-col>
  </ion-row>
</ion-content>
